import { render, staticRenderFns } from "./modalEditSquad.vue?vue&type=template&id=5323e556&"
import script from "./modalEditSquad.vue?vue&type=script&lang=js&"
export * from "./modalEditSquad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports